/**
 * Esqueleto de carregamento das telas de disparo.
 *
 * Reserva a altura dos blocos finais (formulario + previa em duas colunas e
 * a tabela embaixo) para o dado chegar sem salto de layout. `aria-hidden` no
 * desenho e um `role="status"` invisivel para o leitor de tela saber que a
 * pagina esta carregando.
 */
export function EsqueletoDisparos({ variante }: { readonly variante: 'whatsapp' | 'email' }): JSX.Element {
  return (
    <>
      <p role="status" className="sr-only">
        Carregando os disparos
      </p>
      <div aria-hidden="true" className="flex flex-col gap-6">
        {variante === 'email' ? <div className="h-20 animate-pulse rounded-2xl border border-line bg-surface" /> : <div className="h-11 w-72 animate-pulse rounded-xl border border-line bg-surface" />}
        <div className="grid gap-6 lg:grid-cols-5">
          <div className="h-[32rem] animate-pulse rounded-2xl border border-line bg-surface lg:col-span-3" />
          <div className="h-[32rem] animate-pulse rounded-2xl border border-line bg-surface lg:col-span-2" />
        </div>
        <div className="h-72 animate-pulse rounded-2xl border border-line bg-surface" />
      </div>
    </>
  );
}
